"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var USER_SETTINGS_URI = 'gamera/v2/item';
var HUBS_USER_SETTINGS_ENDPOINT = 'users/v1/app/attributes';

var UserSettingsAPI =
/*#__PURE__*/
function () {
  function UserSettingsAPI() {
    (0, _classCallCheck2.default)(this, UserSettingsAPI);
  }

  (0, _createClass2.default)(UserSettingsAPI, null, [{
    key: "getUserSetting",
    value: function getUserSetting(_ref) {
      var namespace = _ref.namespace,
          key = _ref.key,
          value = _ref.value;
      return _apiClient.default.get(USER_SETTINGS_URI + "/" + namespace + "/" + key + ":" + value);
    }
  }, {
    key: "bulkGetUserSettings",
    value: function bulkGetUserSettings(keys) {
      return _apiClient.default.put(HUBS_USER_SETTINGS_ENDPOINT + "/bulk-get", {
        data: {
          keys: keys
        }
      });
    }
  }, {
    key: "saveUserSetting",
    value: function saveUserSetting(_ref2) {
      var key = _ref2.key,
          value = _ref2.value;
      return _apiClient.default.post(HUBS_USER_SETTINGS_ENDPOINT, {
        data: {
          key: key,
          value: value
        }
      });
    }
  }]);
  return UserSettingsAPI;
}();

exports.default = UserSettingsAPI;
module.exports = exports.default;